import React, { useState, useEffect } from "react";
import global from "../global.module.css";
import styles from "./styles.module.css";
import { Link } from "gatsby";
import Logo from "./icons/logo";
import cx from "classnames";

const Footer = ({ footer }) => {
  return (
    <div className={styles.background}>
      <div className={styles.root}>
        <div className={cx(global.padding, styles.divider)}>
          <div className={styles.container}>
            <div className={styles.width}>
              <div className={styles.logoWrapper}>
                <Logo className={styles.logo} />
              </div>

              <div className={styles.linksFlex}>
                <span className={styles.linksSubtile}>МЕДИА</span>
                <a
                  href={footer.telegramChannelUrl}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telegram
                </a>

                <a
                  href={footer.instagramUrl}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>

                <a
                  href={footer.twitterUrl}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>

                <a
                  href={footer.facebookUrl}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
                <a
                  href="https://soundcloud.com/guidedao"
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Подкаст
                </a>
              </div>

              <div className={styles.linksFlex}>
                <span className={styles.linksSubtile}>ДОКИ</span>
                <Link to={`/oferta`} className={styles.link}>
                  Оферта
                </Link>

                <Link to={`/termsOfUse`} className={styles.link}>
                  Соглашение
                </Link>

                <Link to={`/privacy`} className={styles.link}>
                  Конфиденциальность
                </Link>
              </div>
              <div className={styles.linksFlex}>
                <span className={styles.linksSubtile}>КОНТАКТЫ</span>

                <a
                  href={`tel:${footer.phone}`}
                  className={[styles.link, styles.phone].join(" ")}
                >
                  {footer.phone}
                </a>

                <a
                  href={footer.telegramUrl}
                  className={styles.link}
                  target="_blank"
                  rel="nofollow"
                >
                  @guidedao_xyz
                </a>

                <a href={`mailto:${footer.email}`} className={styles.link}>
                  {footer.email}
                </a>

                <a
                  href={footer.etherscanWalletUrl}
                  className={styles.link}
                  target="_blank"
                  rel="nofollow"
                >
                  {footer.wallet}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
